import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpError } from 'app/helpers/httpError';
import { ExposedListPublicRegistryCompaniesReq } from 'app/interfaces/requests/Exposed/exposedListPublicRegistryCompaniesReq';
import { ExposedListPublicRegistryPersonsReq } from 'app/interfaces/requests/Exposed/exposedListPublicRegistryPersonsReq';
import { ExposedListPublicRegistryCompaniesRes } from 'app/interfaces/responses/Exposed/exposedListPublicRegistryCompaniesRes';
import { ExposedListPublicRegistryPersonsRes } from 'app/interfaces/responses/Exposed/exposedListPublicRegistryPersonsRes';
import { ExposedReadPublicRegistryBatchRes } from 'app/interfaces/responses/Exposed/exposedReadPublicRegistryBatchRes';
import { ExposedReadPublicRegistryCompaniesRes } from 'app/interfaces/responses/Exposed/exposedReadPublicRegistryCompaniesRes';
import { ExposedReadPublicRegistryPersonsRes } from 'app/interfaces/responses/Exposed/exposedReadPublicRegistryPersonsRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { catchError, Observable, of } from 'rxjs';
import { finalize, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class PublicRegistryService {
    constructor(
        private http: HttpClient,
        private loaderService: LoaderService,
        private alertsService: AlertsService,
        private router: Router,
        public dialog: MatDialog
    ) {}

    public listPersons(
        req: ExposedListPublicRegistryPersonsReq,
        showLoader: boolean = true
    ): Observable<ExposedListPublicRegistryPersonsRes[]> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage('Sæki einstaklinga');
        }

        return this.http.post(environment.localApi + 'publicregistry/listPersons', req).pipe(
            map((res: HttpStatus<ExposedListPublicRegistryPersonsRes[]>) => {
                return res.returnItem;
            }),
            catchError((error) => {
                HttpError(this.alertsService, this.router, error, '', '', '', '');
                return of(null);
            }),
            finalize(() => {
                if (showLoader) {
                    this.loaderService.changeActiveLoaders(-1);
                }
            })
        );
    }

    public getPerson(ssn: string): Observable<ExposedReadPublicRegistryPersonsRes> {
        return this.http.get(environment.localApi + 'publicregistry/persons/' + ssn).pipe(
            map((res: HttpStatus<ExposedReadPublicRegistryPersonsRes>) => {
                return res.returnItem;
            }),
            catchError((error) => {
                HttpError(this.alertsService, this.router, error, '', '', '', '');
                return of(null);
            })
        );
    }

    public listCompanies(
        req: ExposedListPublicRegistryCompaniesReq,
        showLoader: boolean = true
    ): Observable<ExposedListPublicRegistryCompaniesRes[]> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage('Sæki fyrirtæki');
        }

        return this.http.post(environment.localApi + 'publicregistry/listCompanies', req).pipe(
            map((res: HttpStatus<ExposedListPublicRegistryCompaniesRes[]>) => {
                return res.returnItem;
            }),
            catchError((error) => {
                HttpError(this.alertsService, this.router, error, '', '', '', '');
                return of(null);
            }),
            finalize(() => {
                if (showLoader) {
                    this.loaderService.changeActiveLoaders(-1);
                }
            })
        );
    }

    public getCompany(ssn: string): Observable<ExposedReadPublicRegistryCompaniesRes> {
        return this.http.get(environment.localApi + 'publicregistry/companies/' + ssn).pipe(
            map((res: HttpStatus<ExposedReadPublicRegistryCompaniesRes>) => {
                return res.returnItem;
            }),
            catchError((error) => {
                HttpError(this.alertsService, this.router, error, '', '', '', '');
                return of(null);
            })
        );
    }

    public batchLookup(ssns: string[]): Observable<ExposedReadPublicRegistryBatchRes[]> {
        return this.http
            .post<HttpStatus<ExposedReadPublicRegistryBatchRes[]>>(`${environment.localApi}publicregistry/batchLookup`, { ssns })
            .pipe(
                map((res) => res.returnItem),
                catchError((error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                    return of([]);
                })
            );
    }
}
